export class InterventionFileUploadOutDTO {
  originalFileName!: string;
  mimeType!: string;
  fileName!: string;
  ticketId!: string;
  base64Preview?: string;
}
